import * as EventEmitter from 'events';
import camelCase = require('lodash/camelCase');

import {
  WS_PONG,
  WS_CLEAR,
  WS_STDOUT,
  WS_STDERR,
  WS_RESULT,
  WS_LANGUAGE,
  WS_CURRENT_STATE,

  WS_SEND_RUN,
  WS_SEND_PING,
  WS_SEND_LANGUAGE,
  WS_SEND_SWAP_ROLE,
  WS_SEND_END_INTERVIEW,
} from '../../redux/modules/web-socket/constants';

import {WebSocketClient} from '../session-router/web-socket-client';
import {
  ICurrentStateResponse,
  currentStateResponse,
  swapRolesResponse,
  languageResponse,
} from './data';

export class StubWebSocketClient extends WebSocketClient {
  private isInterviewer: boolean;

  constructor(
    connect: () => void,
    runCommand: (type: string, payload: any) => void,
    disconnect: () => void,
  ) {
    super('', connect, runCommand, disconnect);

    this.client.emit('open');
    this.emulateCurrentState();
  }

  public send(command: string, data: any = {}): void {
    if (!this.client) {
      return;
    }

    switch (command) {
      case WS_SEND_RUN: return this.emulateRun();
      case WS_SEND_PING: return this.emulatePing();
      case WS_SEND_SWAP_ROLE: return this.emulateSwapRoles();
      case WS_SEND_END_INTERVIEW: return this.emulateEndInterview();
      case WS_SEND_LANGUAGE: return this.emulateLanguage(data.language);
      default: return;
    }
  }

  public close(): void {
    this.client.emit('close');
    this.client.removeListener('open', this.onOpen);
    this.client.removeListener('message', this.onMessage);
    this.client.removeListener('close', this.onClose);
    this.client = null;
  }

  protected initClient(): void {
    this.client = new EventEmitter();

    this.client.addListener('open', this.onOpen);
    this.client.addListener('message', this.onMessage);
    this.client.addListener('close', this.onClose);
  }

  private emulatePing(): void {
    this.emulateMessage(WS_PONG);
  }

  private emulateRun(): void {
    this.emulateMessage(WS_CLEAR);
    setTimeout(() => {
      this.emulateMessage(WS_STDOUT, 'Hello World! I\'m a standard output line!');
      this.emulateMessage(WS_STDOUT, 'Code execution output will be shown here in your real interview');
      this.emulateMessage(WS_STDERR, 'Compilation and runtime errors will be colored in red.');
      this.emulateMessage(WS_RESULT);
    }, 200);
  }

  private emulateLanguage(language: string): void {
    this.emulateMessage(WS_LANGUAGE, languageResponse(language));
  }

  private emulateSwapRoles(): void {
    this.emulateCurrentState(swapRolesResponse(this.isInterviewer));
  }

  private emulateCurrentState(data: ICurrentStateResponse = currentStateResponse()): void {
    this.emulateMessage(WS_CURRENT_STATE, data);
    this.isInterviewer = data.isInterviewer;
  }

  private emulateEndInterview(): void {
    window.location.href = currentStateResponse().dashboardUrl;
  }

  private emulateMessage(command: string, data: any = {}): void {
    const event = {
      data: JSON.stringify({
        command: camelCase(command.replace('WS_', '').toLowerCase()),
        data,
      }),
    };

    setTimeout(() => {
      this.client.emit('message', event);
    }, 100);
  }
}
